import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./rootReducer";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: [
    "formData",
    "userInfo",
    "otpReducer",
    "uploadDocumentReducer",
    "consentReducer",
    "conditionalRendering",
    "recursive",
    "consentReducer",
    "dashboardReducer",
    "requestedDocReducer",
    "fieldRecursiveReducer",
    "dashboardDetailReducer",
    "stepperReducer",
    "configurationReducer",
    "popupReducer",
    "vkycReducer",
    "requestedSupportingDocs",
    "downloadRepo",
    "verificationResponses",
    "activityListReducer",
    "commentsReducer",
    "usersReducer",
    "urlEncryption",
    "staticData",
    "guardianRecursive"
    ],
  whitelist: ["loggedInUserInfo"], // only dashboardDetailReducer will be persisted
  // blacklist: ['formData', 'userInfo', 'otpReducer','uploadDocumentReducer', 'consentReducer','dashboardReducer','conditionalRendering', 'recursive', 'consentReducer', 'commentsReducer','requestedDocReducer','fieldRecursiveReducer','dashboardDetailReducer' , 'stepperReducer' , 'configurationReducer', 'popupReducer','vkycReducer','requestedSupportingDocs','downloadRepo',"verificationResponses","activityListReducer","commentsReducer","urlEncryption","staticData"],
  // whitelist:["loggedInUserInfo"] // only dashboardDetailReducer will be persisted
};

const reducers = combineReducers({ ...rootReducer });
const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== "production", // enable redux devtools only in development
});

export const persistor = persistStore(store);
